import { PORTFOLIO_CUSTODY_EVIDENCE_LIST } from '../../operations/portfolio-custody.operations.js';
import { PORTFOLIO_PERFORMANCE_LIST } from '../../operations/portfolio-performance.operations.js';
import { REPORTS_VIEW, REPORT_DETAIL_READ, HOLDINGS_VIEW, RECONCILIATION_VIEW, CORPORATE_ACTIONS_VIEW, } from '../../operations/operation-ids.js';
/**
 * Organization report reader: read access to reporting and read-only views
 * across portfolio, custody evidence, reconciliation, and corporate-action
 * surfaces. Mutating portfolio and settlement operations are intentionally
 * excluded.
 */
export const ORGANIZATION_REPORT_READER_OPERATIONS = [
    REPORTS_VIEW,
    REPORT_DETAIL_READ,
    HOLDINGS_VIEW,
    PORTFOLIO_PERFORMANCE_LIST,
    PORTFOLIO_CUSTODY_EVIDENCE_LIST,
    RECONCILIATION_VIEW,
    CORPORATE_ACTIONS_VIEW,
];
